import 'css-chunksrc/client/pages/exportsPage/customCpamReport/filters/styles.scss';export default {
  "filters": "_filters_1ccxa_1",
  "resetButton": "_resetButton_1ccxa_17",
  "label": "_label_1ccxa_25",
  "section": "_section_1ccxa_32"
};